namespace SPA {
	export interface IContactStatus {
		ContactID?: number;
		StatusID?: number;
		Name?: IContactStatusName | '';
		ObjectNumber?: string;
	}

	export type IContactStatusName = 'owner' | 'bidder' | 'seller' | 'adviser' | 'partner' | 'customer' | 'contact';

	export class ContactStatus extends Backbone.Model implements IContactStatus {
		[key: string]: any;

		get ContactID(): number {
			return this.get('ContactID') || 0;
		}

		set ContactID(ContactID: number) {
			this.set('ContactID', ContactID);
		}

		get StatusID(): number {
			return this.get('StatusID') || 0;
		}

		set StatusID(StatusID: number) {
			this.set('StatusID', StatusID);
		}

		get Name(): IContactStatusName | '' {
			return this.get('Name');
		}

		set Name(Name: IContactStatusName | '') {
			this.set('Name', Name);
		}

		get ObjectNumber(): string {
			return this.get('ObjectNumber') || '';
		}

		set ObjectNumber(ObjectNumber: string) {
			this.set('ObjectNumber', ObjectNumber);
		}

		public constructor(attributes: IContactStatus, options?: any) {
			if (options === undefined) {
				options = {};
			}

			super(attributes, options);
		}

		public preinitialize(attributes?: IContactStatus, options?: any): void
		{
			this.idAttribute = 'StatusID';
		}

		public defaults(): IContactStatus
		{
			return {
				ContactID: 0,
				StatusID: 0,
				Name: '',
				ObjectNumber: '',
			};
		}
	}
}
